import EventEmitter from "eventemitter3";

class QuizItem extends EventEmitter {
  // ---------------------------------------------------------------------------------------------------------
  // --	QuizItem
  // ---------------------------------------------------------------------------------------------------------

  constructor(dom, index) {
    super();

    //dom参照
    this.$dom = dom;
    this.$btnMaru = this.$dom.find(".maru >a");
    this.$btnBatsu = this.$dom.find(".batsu >a");

    //順番
    this.index = index;

    //選択内容
    this.selectedVal = -1;

    //ボタンアクション
    this.$btnMaru.on("click", (e) => {
      this.update(1);
      return false;
    });
    this.$btnBatsu.on("click", (e) => {
      this.update(0);
      return false;
    });
  }

  /**
   * 表示更新
   */
  update(val) {
    //選択したデータを保持
    this.selectedVal = val;

    //選択肢によって表示更新
    switch (this.selectedVal) {
      case 0:
        this.$btnMaru.removeClass("selected");
        this.$btnBatsu.addClass("selected");
        break;
      case 1:
        this.$btnMaru.addClass("selected");
        this.$btnBatsu.removeClass("selected");
        break;
      default:
        this.$btnMaru.removeClass("selected");
        this.$btnBatsu.removeClass("selected");
        break;
    }

    //注意状態解除
    this.$dom.removeClass("caution");

    //イベント発行
    this.emit("UPDATE", this);
  }

  /**
   * 選択済みかどうか
   */
  isSelected() {
    return this.selectedVal != -1;
  }

  /**
   * 入力チェック
   */
  check() {
    if (this.selectedVal == -1) {
      this.$dom.addClass("caution");
      return false;
    } else {
      this.$dom.removeClass("caution");
      return true;
    }
  }

  /**
   * 位置取得
   */
  getTop() {
    return this.$dom.position().top;
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default QuizItem;
